
import { Vue, Component, Ref } from 'vue-property-decorator';
import { VForm } from '@/features/common/types';
import PasswordInput from '@/features/common/components/PasswordInput.vue';
import {
  deleteLastLoginEmail, getLastLoginEmail, saveCurrentLoggedInUser, saveLastLoginEmail,
} from '@/features/auth/helpers';
import SocialLinks from '@/features/auth/components/signIn/SocialLinks.vue';
import { requiredRules } from '@/features/common/helpers/validationRules';
import { SignInData } from '../../types';
import { signInUser } from '../../services/auth.services';

@Component({
  components: {
    PasswordInput,
    SocialLinks,
  },
})
export default class LoginCard extends Vue {
  @Ref('form') form!: VForm;

  private data: SignInData = {
    login: '',
    password: '',
  }

  private loading = false;

  private loginError = {
    isShow: false,
    message: this.$t('signIn.loginFailed') as string,
  };

  private rememberEmail = false;

  private requiredRules = requiredRules;

  private created(): void {
    const lastLoginEmail = getLastLoginEmail();

    if (lastLoginEmail) {
      this.data.login = lastLoginEmail;
      this.rememberEmail = true;
    }
  }

  private performRememberMe() {
    if (this.rememberEmail) {
      saveLastLoginEmail(this.data.login);
    } else {
      deleteLastLoginEmail();
    }
  }

  private async submit(): Promise<void> {
    this.loginError.isShow = false;

    const isValid = this.form.validate();
    if (!isValid) return;

    this.performRememberMe();

    this.loading = true;
    const {
      successful,
      tokenData,
      errorType,
      errorMessage,
    } = await signInUser(this.data);
    this.loading = false;

    if (successful && tokenData) {
      saveCurrentLoggedInUser({ email: this.data.login });
      this.$store.dispatch(
        'signIn',
        { tokenData, redirectTo: this.$route.query.redirectTo },
      );
      return;
    }

    this.loginError.isShow = true;

    if (!successful && errorType === 'UserInfoIsLoginDisabledException') {
      this.loginError.message = this.$t('signIn.loginDisabled') as string;
      return;
    }

    this.loginError.message = errorMessage || this.$t('signIn.loginFailed') as string;
  }
}
